export default "__VITE_ASSET__BwiXU4U9__"